// @ts-check

import { useMutation } from "@apollo/client";
import { upsertTagProperties as upsertTagPropertiesMutation } from "src/queries/mutations/upsertTagProperties.graphql";
import { updatePersonAttributes as updatePersonAttributesMutation } from "src/queries/mutations/updatePersonAttributes.graphql";
import { updateTeamAttributes as updateTeamAttributesMutation } from "src/queries/mutations/updateTeamAttributes.graphql";
import { ENTITY_TYPES } from "src/consts/entityTypes";

const ENTITY_MUTATIONS = {
  person: updatePersonAttributesMutation,
  team: updateTeamAttributesMutation,
  tag: upsertTagPropertiesMutation,
};

const ENTITY_ID_FIELDS = {
  person: "entityId",
  team: "groupId",
  tag: "tagId",
};

/**
 * @param {Object} param0
 * @param {string} param0.entityType
 * @param {string} param0.entityId
 * @returns {Function}
 */
export const useUpdateBackground = ({ entityType, entityId }) => {
  const mutation = ENTITY_MUTATIONS[entityType];
  const idField = ENTITY_ID_FIELDS[entityType];

  const [updateAttributesMutation] = useMutation(mutation);

  const updateAttributes = async (newAttributes) => {
    const variables = {
      [idField]: entityId,
    };

    if (entityType === ENTITY_TYPES.TAG) {
      variables.properties = newAttributes;
    } else {
      variables.attributes = newAttributes;
    }

    await updateAttributesMutation({
      variables,
    });
  };

  return updateAttributes;
};
